module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "home without-padding",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "medium-div without-padding"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/logoPonce.png')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "div-register-button"
  }, [_c('v-btn', {
    staticClass: "register-button",
    on: {
      "click": _vm.signUpButton
    }
  }, [_vm._v("Registrate con tu correo")])], 1), _vm._v(" "), _c('p', {
    staticClass: "sign-in-text"
  }, [_vm._v("Ya tenes tu cuenta? "), _c('a', {
    staticClass: "sign-in-text",
    on: {
      "click": _vm.signInButton
    }
  }, [_c('u', [_vm._v("Ingresa")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f204d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 766
// module chunks = 10